const FacebookIcon = () => {
  return <img style={{ height: '25px' }} alt="" src="/images/facebook.svg" />;
};

FacebookIcon.displayName = 'FacebookIcon';

export default FacebookIcon;
